import { Component, h, Element, Host } from '@stencil/core';

/**
 * COMPNAME is for creating a container for various pieces of meta information for a journal article. It should contain one or more aafp-journal-article-information-item components. If a given piece of meta information does not apply to the article, that item should be omitted.
 */
@Component({
  tag: 'aafp-journal-article-information',
  shadow: false,
})
export class AafpJournalArticleInformation {
  @Element() element: HTMLElement;

  render() {
    return (
      <Host role="list" class="adl-journal-article-information adl-space__sm__m-v-sm">
        <slot></slot>
      </Host>
    );
  }
}
